"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProductItemToJSON = exports.AnalyticsProductItemFromJSONTyped = exports.AnalyticsProductItemFromJSON = exports.instanceOfAnalyticsProductItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AnalyticsProductItem interface.
 */
function instanceOfAnalyticsProductItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAnalyticsProductItem = instanceOfAnalyticsProductItem;
function AnalyticsProductItemFromJSON(json) {
    return AnalyticsProductItemFromJSONTyped(json, false);
}
exports.AnalyticsProductItemFromJSON = AnalyticsProductItemFromJSON;
function AnalyticsProductItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'daysInStore': !(0, runtime_1.exists)(json, 'daysInStore') ? undefined : json['daysInStore'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'productId': !(0, runtime_1.exists)(json, 'productId') ? undefined : json['productId'],
        'quantity': !(0, runtime_1.exists)(json, 'quantity') ? undefined : json['quantity'],
        'sales': !(0, runtime_1.exists)(json, 'sales') ? undefined : json['sales'],
        'profit': !(0, runtime_1.exists)(json, 'profit') ? undefined : json['profit'],
        'margin': !(0, runtime_1.exists)(json, 'margin') ? undefined : json['margin'],
    };
}
exports.AnalyticsProductItemFromJSONTyped = AnalyticsProductItemFromJSONTyped;
function AnalyticsProductItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'daysInStore': value.daysInStore,
        'image': value.image,
        'name': value.name,
        'price': value.price,
        'productId': value.productId,
        'quantity': value.quantity,
        'sales': value.sales,
        'profit': value.profit,
        'margin': value.margin,
    };
}
exports.AnalyticsProductItemToJSON = AnalyticsProductItemToJSON;
